import { useState } from 'react';
import constate from 'constate';

function useTodoTasksState() {
    // Set to false to update global todo_tasks counter
    const [todoTasksNeedsUpdate, setTodoTasksNeedsUpdate] = useState(false);
    const hasTodoTasks = todoTasksNeedsUpdate;

    return { todoTasksNeedsUpdate, setTodoTasksNeedsUpdate, hasTodoTasks };
}

const [TodoTasksStateProvider, useTodoTasksStateContext] = constate(useTodoTasksState);

export {
    TodoTasksStateProvider,
    useTodoTasksStateContext
};
